import { gql } from '@apollo/client';
import { useMemo } from 'react';
import { useGraphql } from 'utils/hooks/useGraphql';
import { Placement } from '../types';

export const FetchPlacementByIdQuery = gql`
  query fetchPlacementById($id: Long!) {
    placement(id: $id) {
      payload {
        id
        isArchived
        fields {
          placementName
          description
          mediaLayout
          campaignLimit
          hasTitle
          hasBody
          hasMedia
          hasDataFeeds
          hasOpenAction
          actionButtons {
            title
          }
          payload
          destinations
          textFields
        }
      }
      message
    }
  }
`;

export const useQueryPlacementById = (placementId?: number, onComplete?: (res: any) => void) => {
  const { data, isLoading, error } = useGraphql(FetchPlacementByIdQuery, {
    skip: !placementId,
    variables: {
      id: placementId,
    },
    onCompleted: onComplete,
  });

  const placement: Placement = useMemo(
    () => ({
      id: data?.placement?.payload?.id,
      isArchived: data?.placement?.payload?.isArchived,
      ...data?.placement?.payload?.fields,
    }),
    [data],
  );

  return {
    placement,
    loading: isLoading,
    error,
  };
};
